export const GET_USER_SUCCESS = "GET_USER_SUCCESS";

export const GET_SUGGESTIONS_SUCCESS = "GET_SUGGESTIONS_SUCCESS"